import { render, staticRenderFns } from "./GuestWelcome.vue?vue&type=template&id=5dfea17b&"
import script from "./GuestWelcome.vue?vue&type=script&lang=js&"
export * from "./GuestWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports